import { formatPrice } from "@ac-expo/utils";
import { cn } from "../../../utils";

interface ElementType {
  name: string;
  price: string;
}

interface PricedElementListProps {
  elements: ElementType[];
  openTicketing: () => void;
}

export function PricedElementList({
  elements,
  openTicketing,
}: PricedElementListProps) {
  if (elements.length === 0) {
    return null;
  }

  return (
    <div className="rounded-lg border border-gray-300">
      {elements.map(({ name, price }, index) => {
        return (
          <div
            role="button"
            tabIndex={0}
            key={index}
            className={cn("flex items-center justify-between p-4", {
              "border-b border-gray-300": index !== elements.length - 1,
            })}
            onKeyDown={openTicketing}
            onClick={openTicketing}
          >
            <span className="text-lg font-bold">{name}</span>
            <span className="pl-4 text-sm font-bold">
              {parseFloat(price) === 0 ? "Gratuit" : formatPrice(price, 2)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
